import React from "react";
import { CheckCircle2Icon, TargetIcon } from "lucide-react";
import { SectionCta } from "../SectionCta";
import { images, volumes } from "../../data/content";
export function Volumes() {
  return <section aria-labelledby="introducing-title" data-id="element-343" data-mp="2x0ib61q82304">
      <div className="bg-navy-950 px-4 py-16 text-white sm:px-6 sm:py-24" data-id="element-344" data-mp="2x3cwdvh27rul">
        <div className="mx-auto max-w-4xl text-center" data-id="element-345" data-mp="2sywt81ytyyj2">
          <p className="text-sm font-bold uppercase tracking-[0.2em] text-gold-400" data-id="element-346" data-mp="2o0brtz7ue8t1">Introducing</p>
          <h2 id="introducing-title" className="mt-3 font-display text-[30px] font-black leading-tight sm:text-5xl" data-id="element-347" data-mp="2ja52fx5iak9q">
            Mandibular Complete Denture Blueprint™
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-lg font-semibold text-white/85 sm:text-xl" data-id="element-348" data-mp="29bpbpvae5d0r">
            The 6-volume clinical decision system for lower complete denture assessment, stability & treatment planning
          </p>
          <img src={images.mockup} alt="The complete Blueprint collection" className="mx-auto mt-10 w-full max-w-2xl drop-shadow-[0_30px_40px_rgba(0,0,0,0.5)]" data-id="element-349" data-mp="20ar4730qundf" />
          <p className="mx-auto mt-10 max-w-2xl text-left text-[17px] leading-relaxed text-white/75 sm:text-center" data-id="element-350" data-mp="37xe7dr5xr1fe">
            Instead of relying on scattered notes or trying to remember every relevant consideration during a
            challenging appointment, you'll have a structured educational reference organized around the clinical
            workflow — from the first examination to functional assessment, impression planning, occlusal
            considerations, and post-delivery troubleshooting.
          </p>
          <p className="mt-6 font-display text-xl font-extrabold text-gold-400 sm:text-2xl" data-id="element-351" data-mp="3cuxiii7c6y34">
            Six focused volumes. One connected clinical reasoning framework.
          </p>
        </div>
      </div>

      <div className="bg-white px-4 py-16 sm:px-6 sm:py-24" data-id="element-352" data-mp="21ez6q6krxxy7">
        <div className="mx-auto max-w-3xl text-center" data-id="element-353" data-mp="26fn4rc7f7f1x">
          <h2 className="font-display text-[28px] font-black leading-tight text-ink sm:text-4xl" data-id="element-354" data-mp="26d0qyutxs3b9">
            What's Inside Your Complete Blueprint?
          </h2>
        </div>

        <div className="mx-auto mt-12 max-w-5xl space-y-6" data-id="element-355" data-mp="70tyb00jvekr">
          {volumes.map(v => <article key={v.number} className="overflow-hidden rounded-3xl bg-white shadow-[0_10px_40px_-18px_rgba(10,29,64,0.35)] ring-1 ring-navy-900/10" data-id="element-356" data-mp="27irgyvqmxsu">
              <div className="flex items-center gap-4 bg-navy-900 px-5 py-5 text-white sm:px-8" data-id="element-357" data-mp="3pfco4j8pp26g">
                <div className="flex h-16 w-16 shrink-0 flex-col items-center justify-center rounded-2xl bg-gold-400 text-navy-950" data-id="element-358" data-mp="3kdnb4y1xiefq">
                  <span className="text-[10px] font-bold uppercase tracking-wider" data-id="element-359" data-mp="3bea2g7lmptw2">Volume</span>
                  <span className="font-display text-3xl font-black leading-none" data-id="element-360" data-mp="1doig9kivmui4">{v.number}</span>
                </div>
                <div className="min-w-0" data-id="element-361" data-mp="19mdrp07aco2c">
                  <h3 className="font-display text-lg font-black uppercase leading-tight sm:text-2xl" data-id="element-362" data-mp="19nf53bbrxmn8">{v.title}</h3>
                  <p className="mt-1 text-sm text-white/75 sm:text-base" data-id="element-363" data-mp="2rifqlgfepv3v">{v.subtitle}</p>
                </div>
              </div>
              <div className="p-5 sm:p-8" data-id="element-364" data-mp="31aljcsdhggk4">
                <p className="text-base leading-relaxed text-muted" data-id="element-365" data-mp="31av9qh2fwpqc">{v.intro}</p>
                <ul className="mt-5 grid gap-x-8 gap-y-3 md:grid-cols-2" data-id="element-366" data-mp="35avm7w5zaqur">
                  {v.points.map(p => <li key={p} className="flex gap-2.5 text-base leading-snug text-ink" data-id="element-367" data-mp="28n8v8droc0op">
                      <CheckCircle2Icon className="mt-0.5 h-5 w-5 shrink-0 text-success" aria-hidden="true" data-id="element-368" data-mp="2dlk4ama5a75v" />
                      {p}
                    </li>)}
                </ul>
                <div className="mt-6 flex gap-3 rounded-2xl bg-brand-soft p-4" data-id="element-369" data-mp="2mm8hxfvmm5i8">
                  <TargetIcon className="mt-0.5 h-5 w-5 shrink-0 text-brand" aria-hidden="true" data-id="element-370" data-mp="3t2asu14sfubt" />
                  <p className="text-base leading-snug text-ink" data-id="element-371" data-mp="1uf32w05a4uj">
                    <strong data-id="element-372" data-mp="e1bg4ju2zr2">Your outcome:</strong> {v.outcome}
                  </p>
                </div>
              </div>
            </article>)}
        </div>

        <SectionCta label="Yes! I want all 6 clinical volumes" data-id="element-373" data-mp="3rm6qev1p6scz" />
      </div>
    </section>;
}